const BOOKS_LLD_PENDING = 'books_lld_pending';
const BOOKS_LLD_FAILED = 'books_lld_failed';
const BOOKS_LLD_DOWNLOADED = 'books_lld_downloaded';
const BOOK_LLD_DOWNLOADED = 'book_lld_downloaded';
const BOOK_LLD_SENDING = 'book_lld_sending';
const BOOKS_LLD_RESET = 'books_lld_reset';

export {
  BOOKS_LLD_DOWNLOADED,
  BOOKS_LLD_FAILED,
  BOOKS_LLD_PENDING,
  BOOKS_LLD_RESET,
  BOOK_LLD_DOWNLOADED,
  BOOK_LLD_SENDING
};



// WEBPACK FOOTER //
// ./src/store/booksLld/types.js